import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Avatar, Button, Carousel, Grid, Image, Typography } from 'antd';
import styles from './TestimonialView.module.less';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';

type Item = {
  description: string;
  userImage?: string;
  companyImage?: string;
  company: string;
  name: string;
  designation: string;
  key: string;
  owner: string;
  testimonialId: string;
  status: string;
};
type Props = {
  items: Item[];
  className?: string;
  slideCount?: boolean;
  guestrec?: boolean;
};

// const contentStyle = {
//   height: '160px',
//   color: '#fff',
//   lineHeight: '160px',
//   textAlign: 'center',
//   background: '#364d79',
// };
const { useBreakpoint } = Grid;

export const TestimonialView: FC<Props> = (props) => {
  const { Text, Paragraph } = Typography;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const carousel = useRef<Carousel>(null);
  const { items, guestrec } = props;
  const [count, setCount] = useState<number>(3);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [hg, setHg] = useState(props.slideCount ?? false);

  const bp = useBreakpoint();

  useEffect(() => {
    if (bp.xl) {
      setCount(3);
    } else if (bp.md) {
      setCount(2);
    } else {
      setCount(1);
    }
  }, [bp.md, bp.xl]);

  const shortDescription = useCallback((text) => {
    if (text.length > 80) {
      const newText = text.substr(0, 80);
      return `${newText}...`;
    }
    return text;
  }, []);

  return (
    <div style={{ width: '100%', display: 'block' }} className={styles.maincon}>
      <Carousel
        dots={false}
        ref={carousel}
        slidesToShow={count}
        style={{ width: 'calc(100% - 40px)', margin: 'auto' }}
        // prevArrow={
        //   <div className={styles.controllerButtonLeft}>
        //     <Button type={'default'} className={styles.controllerButton}>
        //       <ArrowLeftOutlined />
        //     </Button>
        //   </div>
        // }
        // nextArrow={
        //   <div className={styles.controllerButtonRight}>
        //     <Button type={'default'} className={styles.controllerButton}>
        //       <ArrowRightOutlined />
        //     </Button>
        //   </div>
        // }
      >
        {items?.map((item) => {
          return (
            <div className={styles.testimonialCard} key={item.name}>
              <div
                className={
                  hg
                    ? styles.maincontainerh
                    : guestrec
                    ? styles.recruitermaincontainer
                    : styles.maincontainer
                }>
                <div>
                  <Avatar size={guestrec ? 100 : 120} src={item.userImage ?? undefined} />
                </div>

                {/* <div className={styles.text}>
                  <Text> {item.description}</Text>
                </div> */}
                <div className={guestrec ? styles.rectext : styles.text}>{item.description}</div>
                <div style={{ alignSelf: 'center' }}>
                  {item.companyImage && (
                    <Image
                      className={styles.logoContainer}
                      height={guestrec ? 60 : 74}
                      width={guestrec ? 60 : 74}
                      src={item.companyImage}
                      preview={false}
                      alt={`${item.company} Logo`}
                    />
                  )}
                </div>
                <div>
                  <div className={guestrec ? styles.reccompanyName : styles.companyName}>
                    <Text className={guestrec ? 'text-[16px]' : 'text-[18px]'}>{item.company}</Text>
                  </div>
                  <div className={guestrec ? styles.recname : styles.name}>
                    <Text className={guestrec ? 'text-[24px]' : 'text-[28px]'}>{item.name}</Text>
                  </div>
                  <div className={guestrec ? styles.recjobTitle : styles.jobTitle}>
                    <Text className={guestrec ? 'text-[13px]' : 'text-[15px]'}>
                      {item.designation}
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </Carousel>
      <Button
        className={styles.rightArrow}
        shape={'circle'}
        onClick={() => (carousel.current as any)?.next()}>
        <ArrowRightOutlined />
      </Button>
      <Button
        className={styles.leftArrow}
        shape={'circle'}
        onClick={() => (carousel.current as any)?.prev()}>
        <ArrowLeftOutlined />
      </Button>
    </div>
  );
};
